import Link from "next/link"
import { ReactNode } from "react"
import { cn } from "@/lib/utils"

type HomeSectionProps = {
  title: string
  mobileTitle?: string
  titleColor?: string
  viewAllLink: string
  children: ReactNode
  className?: string
  backgroundImage?: string
  overlayColor?: string
  fullWidth?: boolean
}

export const HomeSection = ({
  title,
  mobileTitle,
  titleColor,
  viewAllLink,
  children,
  className = "",
  backgroundImage,
  overlayColor,
  fullWidth = false,
}: HomeSectionProps) => {
  return (
    <section
      className={cn(
        "pt-[75px] pb-[84px]",
        backgroundImage && "relative",
        className
      )}
      style={backgroundImage ? { backgroundImage: `url(${backgroundImage})`, backgroundRepeat: 'repeat', backgroundSize: 'cover' } : undefined}
    >
      {overlayColor && <div className={`absolute inset-0 ${overlayColor} z-0`}></div>}

      <div className={cn("container", overlayColor ? 'relative z-10' : '')}>
        <div className={cn("text-dark02 flex flex-wrap items-center", titleColor)}>
          <h2 className={cn("text-3xl sm:text-5xl font-bold sm:text-left", mobileTitle ? 'hidden lg:block' : '')}>
            {title}
          </h2>
          {mobileTitle && (
            <h2 className="lg:hidden text-3xl sm:text-5xl font-bold text-center sm:text-left">
              {mobileTitle}
            </h2>
          )}
          <div className="flex-1"></div>
          <Link
            className="text-2xl hover:text-gray-300 text-center"
            href={viewAllLink}
          >
            VER TODO
          </Link>
        </div>

        <div className={cn("mt-[63px]", fullWidth ? "-mx-4" : "")}>
          {children}
        </div>
      </div>
    </section>
  )
} 